module.exports = __webpack_public_path__ + "img/中央财经大学.ed5b0fa2.png";